import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormControlLabel, TextField } from '@mui/material';
import { useLazyGetValidateProjectNameQuery } from '~/api/v2/hooks';
import { projectNameRules } from '~/validation/projectSchema';

const ProjectTitleField = () => {
  const {
    register,
    watch,
    setError,
    clearErrors,
    formState: { dirtyFields, errors },
  } = useFormContext();
  const value = watch('name');
  const [validateName, setValidateName] = useState<string>('');
  const [triggerValidateName, { data, isFetching }] = useLazyGetValidateProjectNameQuery();

  const shouldValidate = data && !isFetching && !!validateName && !data?.is_unique && dirtyFields.name;
  const validationMessage = 'Project name is already in use in HDP. The name must be unique.';

  useEffect(() => {
    if (shouldValidate) {
      setError('name', { type: 'validate', message: validationMessage });
    } else {
      clearErrors('name');
    }
  }, [shouldValidate]);

  const nameField = register('name', {
    onChange: () => {
      setValidateName('');
      clearErrors('name');
    },
  });

  return (
    <FormControlLabel
      required
      label="PROJECT TITLE"
      control={
        <TextField
          helperText={
            (errors.name?.message as string) ||
            `Use up to 128 characters (alphanumeric, whitespaces and _.:/=+-@{}[]()&^%$#!\\~${'`"'}'|?,;<>)`
          }
          {...nameField}
          error={!!errors.name}
          slotProps={{ htmlInput: { maxLength: projectNameRules.max } }}
          onBlur={(event) => {
            nameField.onBlur(event);
            const name = value ?? '';
            const canValidate = !!name && name.length <= projectNameRules.max && dirtyFields.name && !errors.name;
            if (canValidate) {
              setValidateName(name);
              // preferCacheValue: false forces a fresh request so a re-entered duplicate is re-checked
              triggerValidateName({ name }, false);
            } else {
              setValidateName('');
            }
          }}
        />
      }
    />
  );
};

export default ProjectTitleField;
